import { addDays, format, isAfter, parseISO } from 'date-fns';
import { z } from 'zod';

export const holidayDurationBoundSchema = z.object({
  value: z.string(),
  inclusive: z.boolean(),
});

export const holidayCreateSchema = z.codec(
  z
    .object({
      id: z.number().optional(),
      name: z.string('Nazwa jest wymagana').min(1, 'Nazwa jest wymagana'),
      startDate: z.iso.date({ message: 'Data początkowa jest wymagana' }),
      endDate: z.iso.date({ message: 'Data końcowa jest wymagana' }),
    })
    .refine((value) => !isAfter(new Date(value.startDate), new Date(value.endDate)), {
      message: 'Data końcowa musi być po dacie początkowej',
      path: ['endDate'],
    }),
  z.object({
    id: z.number().optional(),
    name: z.string('Nazwa jest wymagana').min(1, 'Nazwa jest wymagana'),
    duration: z.tuple([holidayDurationBoundSchema, holidayDurationBoundSchema]),
  }),
  {
    decode: (date) => {
      const start = parseISO(date.startDate);
      const endExclusive = addDays(parseISO(date.endDate), 1);
      return {
        id: date.id,
        name: date.name,
        duration: z.tuple([holidayDurationBoundSchema, holidayDurationBoundSchema]).parse([
          { value: start.toISOString(), inclusive: true },
          { value: endExclusive.toISOString(), inclusive: true },
        ]),
      };
    },
    encode: (date) => {
      const startDate = parseISO(date.duration[0].value);
      const endExclusive = parseISO(date.duration[1].value);
      const endDate = addDays(endExclusive, -1);
      return {
        name: date.name,
        startDate: format(startDate, 'yyyy-MM-dd'),
        endDate: format(endDate, 'yyyy-MM-dd'),
      };
    },
  }
);

export type HolidayCreateSchemaInput = z.infer<typeof holidayCreateSchema.in>;
export type HolidayCreateSchemaOutput = z.infer<typeof holidayCreateSchema.out>;
